module.exports = __webpack_public_path__ + "img/hero_default.17ceeaf1.png";